import React, { CSSProperties, FC } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import { staticMultimedia } from 'utils'

import styles from './styles.module.scss'

interface IProps {
  children: React.ReactNode,
  style?: CSSProperties
  withBackgroundImage?: boolean
  id?: string
}

export const SectionContainer: FC<IProps> = observer((
  {
    children,
    style,
    withBackgroundImage,
    id
  }) => {

  return (
    <section style={{
               // @ts-ignore
               '--backgroundImageUrl': `url(${staticMultimedia.vr1bg_section})`,
               ...style
             }}
             id={id ? id : undefined}
             className={cn({
               [styles.section]: true,
               [styles.sectionBackgroundImage]: withBackgroundImage
             })}

    >
      {children}
    </section>
  )
})
